"use client";

import { motion } from "framer-motion";
import styles from "./ProcedureStep.module.css";

interface ProcedureStepProps {
  stepNumber: number;
  title: string;
  description: string;
  imageSrc: string;
  stepClass?: string;
}

export default function ProcedureStep({
  stepNumber,
  title,
  description,
  imageSrc,
  stepClass,
}: ProcedureStepProps) {
  return (
    <motion.div
      className={`${styles.procedureStep} ${stepClass ?? ""}`}
      initial={{ opacity: 0, y: 50, scale: 0.9 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <div className={styles.stepNumber}>
        <span className={styles.stepNumberText}>{stepNumber}</span>
      </div>

      <div className={styles.stepImage}>
        <img src={imageSrc} alt={title} className={styles.stepImageImg} />
      </div>

      <div className={styles.stepContent}>
        <h3 className={styles.stepTitle}>{title}</h3>
        <p className={styles.stepDescription}>{description}</p>
      </div>
    </motion.div>
  );
}
